'use client';

import { useCurrency } from '../../../_components/CurrencyProvider';

interface MobileFindTicketsBarProps {
  minPrice: number | null;
  currency: string;
  isSoldOut: boolean;
  onFindTickets: () => void;
}

/**
 * Mobile sticky "Find Tickets" bar — matches `theaters-cms-reference-code/pages/ShowsDetailPage.html`:
 * `<div class="find-ticket-bx shadow-md">
 *    <div class="d-flex justify-content-between align-items-center">
 *      <div class="price text-primary fontweight600 h6 mt-2 show-minimum-price">From £...</div>
 *      <button onclick="openMobileWidget()">Find Tickets</button>
 *    </div>
 *  </div>`
 *
 * Hidden on desktop (> 480px) and visible as a fixed bottom bar on mobile viewports.
 * Clicking "Find Tickets" invokes `onFindTickets()` to toggle the LTD.Calendar mobile drawer/overlay.
 */
export function MobileFindTicketsBar({
  minPrice,
  currency,
  isSoldOut,
  onFindTickets,
}: MobileFindTicketsBarProps) {
  const { formatPrice } = useCurrency();

  const formattedPrice =
    isSoldOut || minPrice == null || minPrice <= 0
      ? 'Sold out'
      : `From ${formatPrice(minPrice, currency)}`;

  return (
    <div className="find-ticket-bx shadow-md">
      <div className="d-flex justify-content-between align-items-center">
        <div className="price text-primary fontweight600 h6 mt-2 show-minimum-price">
          {formattedPrice}
        </div>
        <button
          type="button"
          onClick={onFindTickets}
          disabled={isSoldOut}
        >
          Find Tickets
        </button>
      </div>
    </div>
  );
}
